import React, {useEffect, useRef, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OptIn from "./formSteps/hero_company_form_steps/OptIn"
import CompanyInformations from "./formSteps/hero_company_form_steps/CompanyInformations"
import useFormContext from "../hooks/useFormContext"
import PersonalInformations from "./formSteps/hero_company_form_steps/PersonalInformations";
import CompanyActivities from "./formSteps/hero_company_form_steps/CompanyActivities";
import Documents from "./formSteps/hero_company_form_steps/Documents";

const FormInputs = () => {

    const { page } = useFormContext()

    const display = {
        0: <PersonalInformations />,
        1: <CompanyInformations />,
        2: <CompanyActivities />,
        3: <Documents />,
        4: <OptIn />
    }

    const content = (
        <div className="form-inputs flex-col">
            {display[page]}
        </div>
    )


    return content
}
export default FormInputs